import React from 'react'
import { connect } from 'react-redux'

import { callFileApi } from '../../../actions/api'
import { apiResourceEndpoint } from '../../../constants/routes'

import SHSForm from '../../utils/shs-form'
import InputElement from '../../utils/input'
import { closeDrawer } from '../../../reducers/ui-drawer'

const CreatePhoto = ({ dispatch, chef }) => {
    const submitFX = (formData, formId) => {
        // Add other form fields
        formData.append('chef_id', chef.id)
        formData.append('order', chef.photoCount + 1)

        dispatch(callFileApi(apiResourceEndpoint('chefs/chef-photos', 'CREATE'), formData, formId))
    }

    const successFX = () => {
        dispatch(closeDrawer())
    }

    return (
        <div>
            <h3>Add Photos</h3>
            <p>Upload one or more photos.</p>
            <SHSForm submitFX={submitFX} successFX={successFX} useFormData={true} resetForm={true}>
                <InputElement
                    label="Image Files"
                    type="file"
                    id="files[]"
                    multiple={true}
                    required />
            </SHSForm>
        </div>

    )
}

export default connect()(CreatePhoto)
